import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/MyBTOnboard/+types/MyBTOnboardPage";
import { fetchMyBTOnboardData } from "@routes/MyBTOnboard/MyBTOnboardPage.server";
import MyBTOnboardPageContent from "@routes/MyBTOnboard/MyBTOnboardPageContent";
import { MyBTOnboardPageContext } from "@routes/MyBTOnboard/utlis/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /mybt/onboard route. */
const MyBTOnboardPage = (): React.ReactElement => {
  const context = useLoaderData<MyBTOnboardPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <MyBTOnboardPageContent {...context.payload.data} />;
};

export default MyBTOnboardPage;

export const loader = async () => await fetchMyBTOnboardData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as MyBTOnboardPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
